import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Pager, Filters, Modal, F, csv, clip } from "../lib/ui.jsx";

export default function ReferenceData() {
  const { table } = useParams();
  const { api, act } = useAuth();
  const [meta, setMeta] = useState(null);
  const [f, setF] = useState({ search: "", from: "", to: "", page: 1 });
  const [e, setE] = useState(null);

  useEffect(() => { setF({ search: "", from: "", to: "", page: 1 }); setE(null); }, [table]);
  useEffect(() => { api("t_meta").then((all) => setMeta(all[table] || null)); }, [api, table]);

  const [d, reload] = useLoad(meta ? "t_list" : null, { t: table, ...f });

  if (meta === null) return <Wait d={null} />;
  if (!meta) return <div className="err">Unknown table.</div>;

  const can = (c) => meta.fl.includes(c);
  const label = (n) => meta.f.find((x) => x[0] === n)?.[1] || n.replace(/_/g, " ");
  const fresh = () => Object.fromEntries(meta.f.map(([n, , ty]) => [n, ty === "flag" ? 1 : ""]));
  const save = async () => { if (await act("t_save", { t: table, ...e }, "Saved.")) { setE(null); reload(); } };

  return (
    <>
      <h1>{meta.title}</h1>
      {meta.note && <p className="muted">{meta.note}</p>}
      <div className="bar">
        {meta.date ? <Filters f={f} setF={setF} /> : (
          <input placeholder="Search" value={f.search} onChange={(x) => setF({ ...f, search: x.target.value, page: 1 })} />
        )}
        {can("c") && <button className="btn" onClick={() => setE(fresh())}>Add</button>}
        <button className="btn g" onClick={() => d?.rows && csv(table, d.rows.map(({ id, ...r }) => r))}>Export page</button>
      </div>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <Tbl rows={d.rows} empty="No records match." onRowClick={can("e") ? (r) => setE({ ...r }) : undefined} cols={[
              ...meta.show.map((n) => [label(n), (r) => (
                meta.f.find((x) => x[0] === n)?.[2] === "flag" || n === "state" || n === "states"
                  ? (+r[n] ? <span className="tag">yes</span> : <span className="tag bad">no</span>)
                  : (/^https?:\/\//.test(r[n]) && /url$/i.test(n) ? <a href={r[n]} target="_blank" rel="noreferrer">open</a> : clip(r[n]))
              )]),
              ["", (r) => (
                <>
                  {can("e") && <button className="btn g s" onClick={() => setE({ ...r })}>Edit</button>}{" "}
                  {can("d") && <button className="btn d s" onClick={() => confirm("Delete this record?") && act("t_delete", { t: table, id: r.id }, "Deleted.").then(reload)}>Delete</button>}
                </>
              )],
            ]} />
            <Pager f={f} setF={setF} d={d} />
          </>
        )}
      </Wait>
      {e && (
        <Modal title={e.id ? `Edit ${meta.title}` : `Add ${meta.title}`} onClose={() => setE(null)}>
          <div className="g2">
            {meta.f.map(([n, l, ty, rq]) => ty === "flag" ? (
              <div key={n}>
                <label>{l}</label>
                <select value={+e[n] ? 1 : 0} onChange={(x) => setE({ ...e, [n]: +x.target.value })}>
                  <option value={1}>Yes</option><option value={0}>No</option>
                </select>
              </div>
            ) : ty === "area" ? (
              <div key={n} style={{ gridColumn: "1/-1" }}>
                <label>{l}{rq ? " *" : ""}</label>
                <textarea rows={5} value={e[n] ?? ""} onChange={(x) => setE({ ...e, [n]: x.target.value })} />
              </div>
            ) : (
              <F key={n} label={l + (rq ? " *" : "")} type={ty === "num" ? "number" : "text"} v={e[n]} set={(v) => setE({ ...e, [n]: v })} />
            ))}
          </div>
          <div className="bar"><button className="btn" onClick={save}>Save</button></div>
        </Modal>
      )}
    </>
  );
}
